import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import { TextField, Step } from '../SteppedForm';

import rules from './rules';

const StepCarprovider = (props) => {
  return (
    <Step
      id="carprovider"
      title="Vehicle - Provider"
      skip={(formdata) => {
        return (
          formdata.onboardcar === false ||
          formdata.tiger === true ||
          formdata.vehicles[props.state.vehicle_index].carbuy ||
          !formdata.vehicles[props.state.vehicle_index].carfin ||
          ((!props.networkconfig().carfin || !props.stateconfig().carfinance) &&
            formdata.vehicles[props.state.vehicle_index].carbuy)
        );
      }}>
      <Typography variant="body1" class="formQuestion">
        If you are not purchasing a car with 13cabs but would like finance, please provide the
        details of the person/company you are purchasing a car through.
      </Typography>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField id="carbuy_name" label="Name" required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="carbuy_phone"
            label="Phone"
            type="tel"
            inputProps={{ maxLength: 16 }}
            valid={rules.phone}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField id="carbuy_email" label="Email" valid={rules.email} required />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepCarprovider;
